(() => {
  'use strict';
  if (window.limarteLatestArrivalsLoaded) return;
  window.limarteLatestArrivalsLoaded = true;
  const initialized = new WeakSet();
  function init(root) {
    if (initialized.has(root)) return;
    initialized.add(root);
    const results = root.querySelector('[data-latest-arrivals-results]');
    const status = root.querySelector('[data-latest-arrivals-status]');
    const retry = root.querySelector('[data-latest-arrivals-retry]');
    let busy = false;
    async function load() {
      if (busy) return;
      busy = true; retry.hidden = true; results.setAttribute('aria-busy','true');
      status.textContent = 'Loading latest arrivals…';
      const url = new URL(root.dataset.productsUrl, location.origin);
      if (url.origin !== location.origin) return;
      // Native Shopify sorting covers the full collection, regardless of its default order.
      url.search = '';
      url.searchParams.set('sort_by','created-descending');
      url.searchParams.set('page','1');
      url.searchParams.set('view','latest-arrivals');
      const preview = new URLSearchParams(location.search).get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id',preview);
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(),15000);
      try {
        const response = await fetch(url, {credentials:'same-origin',signal:controller.signal});
        if (!response.ok) throw new Error('Could not load latest products');
        const html = new DOMParser().parseFromString(await response.text(),'text/html');
        const content = html.querySelector('[data-latest-arrivals-content]');
        if (!content || content.dataset.sortBy !== 'created-descending') throw new Error('Invalid sorted product response');
        if (!root.isConnected) return;
        const fragment = document.importNode(content,true);
        if (root.dataset.showVendor === 'false') fragment.querySelectorAll('.product-card-vendor').forEach(node => node.remove());
        results.replaceChildren(fragment);
        status.textContent = '';
        document.dispatchEvent(new Event('limarte:wishlist:refresh'));
      } catch (_) {
        if (!root.isConnected) return;
        results.replaceChildren();
        status.textContent = 'Latest arrivals could not load. Please try again or explore all figures below.';
        retry.hidden = false;
      } finally { clearTimeout(timer); busy = false; results.setAttribute('aria-busy','false'); }
    }
    retry.addEventListener('click',load);
    load();
  }
  const initAll = () => document.querySelectorAll('[data-latest-arrivals]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initAll);
  else initAll();
  document.addEventListener('shopify:section:load',initAll);
})();
